import { render } from "./PromocodeTableBlock.vue?vue&type=template&id=64f1c9ae"
import script from "./PromocodeTableBlock.vue?vue&type=script&lang=js"
export * from "./PromocodeTableBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__